import { useMemo } from "react";
import { RunMetadata } from "../../services/adeBench";
import { SortColumn, SortDirection } from "../components/SortHeader";

interface UseRunsFilteringProps {
  runs: RunMetadata[];
  selectedAgents: string[];
  selectedModels: string[];
  sortColumn: SortColumn;
  sortDirection: SortDirection;
}

export const useRunsFiltering = ({
  runs,
  selectedAgents,
  selectedModels,
  sortColumn,
  sortDirection,
}: UseRunsFilteringProps): RunMetadata[] => {
  return useMemo(() => {
    const filtered = runs.filter(run => {
      if (selectedAgents.length > 0 && !selectedAgents.includes(run.agent_name)) {
        return false;
      }
      if (
        selectedModels.length > 0 &&
        (!run.model_name || !selectedModels.includes(run.model_name))
      ) {
        return false;
      }
      return true;
    });

    filtered.sort((a, b) => {
      let comparison = 0;
      switch (sortColumn) {
        case "start_time":
          comparison =
            new Date(a.start_time || 0).getTime() - new Date(b.start_time || 0).getTime();
          break;
        case "accuracy":
          comparison = (a.accuracy || 0) - (b.accuracy || 0);
          break;
        case "agent":
          comparison = a.agent_name.localeCompare(b.agent_name);
          break;
        case "model":
          comparison = (a.model_name || "").localeCompare(b.model_name || "");
          break;
        case "dataset_size":
          comparison = a.dataset_size - b.dataset_size;
          break;
      }
      return sortDirection === "asc" ? comparison : -comparison;
    });

    return filtered;
  }, [runs, selectedAgents, selectedModels, sortColumn, sortDirection]);
};
